import React from "react";
import { makeStyles } from "@/compat/muiStyles";

const useStyles = makeStyles((theme) => ({
  logo: {
    width: 32,
    height: 32,
    color: "#6050AE",
  }
}));

const NestLogo = () => {
  const classes = useStyles();
  
  return (
    <svg 
      className={classes.logo}
      viewBox="0 0 32 32" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.55556C0 1.59188 1.59188 0 3.55556 0H28.4444C30.4081 0 32 1.59188 32 3.55556V28.4444C32 30.4081 30.4081 32 28.4444 32H3.55556C1.59188 32 0 30.4081 0 28.4444V3.55556ZM15.9912 11.8756C17.3166 11.8756 18.3912 10.8011 18.3912 9.47563C18.3912 8.15015 17.3166 7.07563 15.9912 7.07563C14.6657 7.07563 13.5911 8.15015 13.5911 9.47563C13.5911 10.8011 14.6657 11.8756 15.9912 11.8756ZM10.5425 18.3586C10.5425 15.0968 12.9925 12.4446 16.0026 12.4446C19.0126 12.4446 21.4611 15.0968 21.4611 18.3586V24.9234H18.8203V18.3077C18.8203 16.6329 17.5571 15.2693 16.0026 15.2693C14.448 15.2693 13.1834 16.6329 13.1834 18.3077V24.9234H10.5425V18.3586Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default NestLogo; 